import React from 'react';
import styles from './styles.module.css';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import AttachmentThumb from './AttachmentThumb';
import { getCategoryLabel } from './attachmentCategories';
import { formatFileSize } from './attachmentKinds';

/**
 * Anexos do paciente em grade de miniaturas, agrupados por categoria: cada
 * peça traz a miniatura, o título e a data com o tamanho. Clicar em uma peça
 * abre o visualizador.
 */
const AttachmentList = ({ list, onSelect, groupByCategory = true }) => {
    const items = list || [];

    const buildGroups = () => {
        if (!groupByCategory) {
            return [{ key: 'all', label: null, items: items }];
        }

        const groups = [];

        items.forEach((item) => {
            const label = getCategoryLabel(item.category);
            let group = groups.find(current => current.label === label);

            if (!group) {
                group = { key: label, label: label, items: [] };
                groups.push(group);
            }

            group.items.push(item);
        });

        return groups;
    };

    const getMeta = (item) => {
        return [
            item.documentDate ? dayjs(item.documentDate).format('DD/MM/YYYY') : '',
            formatFileSize(item.fileSize)
        ].filter(Boolean).join(' · ');
    };

    return (
        <Box className={styles.list}>
            {buildGroups().map((group) => (
                <Box key={group.key} className={styles.group}>
                    {group.label && (
                        <Typography component="span" className={styles.groupTitle}>
                            {group.label}
                        </Typography>
                    )}

                    <Box className={styles.grid}>
                        {group.items.map((item) => (
                            <Box
                                key={item.id}
                                className={styles.tile}
                                onClick={() => onSelect && onSelect(item)}
                            >
                                <Box className={styles.tileThumb}>
                                    <AttachmentThumb attachment={item} size={108} />
                                </Box>
                                <span className={styles.tileTitle}>{item.title || item.originalName}</span>
                                <span className={styles.tileMeta}>{getMeta(item)}</span>
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default AttachmentList;
